/* Noctimoth — sticky moth identity (no scroll-jank) */
(function(){
 'use strict';
 var logo=document.querySelector('.header-wrap .nm-transform-logo');
 if(!logo)return;
 var root=document.documentElement;
 var compact=false,raf=0,flutterTimeout;
 var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 function update(){
  raf=0;
  var next=window.scrollY>92;
  if(next===compact)return;
  compact=next;
  root.classList.toggle('nm-header-compact',next);
  root.classList.remove('nm-moth-flutter');
  if(flutterTimeout)clearTimeout(flutterTimeout);
  if(next&&!reduced.matches){
   void logo.offsetWidth;
   root.classList.add('nm-moth-flutter');
   flutterTimeout=setTimeout(function(){root.classList.remove('nm-moth-flutter')},1850);
  }
 }
 function scroll(){if(!raf)raf=requestAnimationFrame(update)}
 window.addEventListener('scroll',scroll,{passive:true});
 window.addEventListener('pageshow',scroll);
 update();
})();